export default {
  /**
   * @typedef {Object} Upload
   * @property {number|string} id
   * @property {bool} canceling
   * @property {string} bucket
   * @property {string} fileName
   * @property {number} fileSize
   * @property {number} progress
   * @property {bool} uploading
   * @property {bool} uploaded
   * @property {bool} failed
   * @property {number} uploadSize
   */
};
